import { render, staticRenderFns } from "./FundsRequest.vue?vue&type=template&id=642999a0&scoped=true&"
import script from "./FundsRequest.vue?vue&type=script&lang=js&"
export * from "./FundsRequest.vue?vue&type=script&lang=js&"
import style0 from "./FundsRequest.vue?vue&type=style&index=0&id=642999a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642999a0",
  null
  
)

export default component.exports